import { trackEvent } from "@/lib/analytics-events";
import { sendOwnedAnalyticsEvent } from "@/lib/analytics-server";

/** Identify user across all analytics providers. */
export function identifyUser(userId: string, traits?: Record<string, unknown>) {
  if (typeof window === "undefined") return;

  // GA4: set user_id so all subsequent events carry the authenticated
  // identifier. Without this, GA4 reports 100% of users as anonymous.
  try {
    if (typeof window.gtag === "function") {
      window.gtag("set", { user_id: userId });
    }
  } catch {
    // gtag may not be loaded yet; the next event with user_id is enough.
  }

  sendOwnedAnalyticsEvent("user_identified", { user_id: userId, ...(traits ?? {}) });
}

/** Reset user identity on logout. */
export function resetUser() {
  if (typeof window === "undefined") return;
  sendOwnedAnalyticsEvent("user_reset", {});
}

export function trackSignUp(props: { method: string }) {
  trackEvent("sign_up", props);
}
